import type { Locale, LocalizedString } from "../../../core/schema/Locale.js";
import { getTenant } from "../contexts/tenantContextKey.js";
import { translate } from "./translate.js";

export function getTranslate<Translations extends Record<string, LocalizedString>>(
	translations: Translations,
	disableNbspify = false,
) {
	const { locale } = getTenant();
	return <Key extends keyof Translations>(
		key: Key,
		variables: Record<string, string | number> = {},
	): Translations[Key][Locale] => {
		return translate<Translations, Key>(translations, key, locale, variables, disableNbspify);
	};
}
